var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.25H1.25V2V7.14286V7.89286H2H5.42857H6.17857V7.14286V2V1.25H5.42857H2ZM10.5714 8.10714H9.82143V8.85714V14V14.75H10.5714H14H14.75V14V8.85714V8.10714H14H10.5714ZM2 11.5357H1.25V12.2857V14V14.75H2H5.42857H6.17857V14V12.2857V11.5357H5.42857H2ZM10.5714 1.25H9.82143V2V3.71429V4.46429H10.5714H14H14.75V3.71429V2V1.25H14H10.5714Z",
    stroke: "#888281",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.a9091c4173e352d64a8560dc38a7a6ce.svg";
export { ForwardRef as ReactComponent };